<template>
  <div class="page-rotarytable">
    <img class="timg" :class="{'animated' : run === true}" src="@/assets/img/timg.jpg">
    <img class="pointer" :style="{'top': posWidth}" src="@/assets/img/pointer.png">
    <van-button type="info" size="large" round @click="get">抽奖</van-button>
  </div>
</template>

<script>

export default {
  data () {
    return {
      posWidth: '',
      run: false,
      prize: 1
    }
  },
  created () {
    this.picSize = document.documentElement.clientWidth * 0.55 - 20 + 'px'
    this.posWidth = (document.body.clientWidth / 2 - 30) + 'px'
  },
  methods: {
    get () {
      this.run = false
      setTimeout(() => {
        this.run = true
      }, 300)
    }
  }
}
</script>

<style lang="scss">
  .page-rotarytable {
    width: 100%;
    height: 100%;
    position: relative;
    .timg {
      position: absolute;
      top: 0;
      left: 0;
    }
    .pointer {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      margin-left: -30px;
    }
    .timg.animated {
      animation: rotate1 1s ease-in-out .5s forwards, rotate1_end 5s ease-in-out 0s forwards;
      -webkit-animation: rotate1 1s ease-in-out .5s forwards, rotate1_end 5s ease-in-out 0s forwards;
    }
    .van-button {
      position: absolute;
      bottom: 60px;
    }
    @keyframes rotate1 {
      0% {
        transform: rotate(0deg)
      }
      100% {
        transform: rotate(6000deg)
      }
    }
    @keyframes rotate1_end {
      0% {
        transform: rotate(6000deg)
      }
      100% {
        transform: rotate(1080deg)
      }
    }
    // @keyframes rotate2 {
    //   0% {
    //     transform: rotate(0deg)
    //   }
    //   100% {
    //     transform: rotate(120deg)
    //   }
    // }
    // @keyframes rotate3 {
    //   0% {
    //     transform: rotate(0deg)
    //   }
    //   100% {
    //     transform: rotate(180deg)
    //   }
    // }
    // @keyframes rotate4 {
    //   0% {
    //     transform: rotate(0deg)
    //   }
    //   100% {
    //     transform: rotate(240deg)
    //   }
    // }
    // @keyframes rotate5 {
    //   0% {
    //     transform: rotate(0deg)
    //   }
    //   100% {
    //     transform: rotate(300deg)
    //   }
    // }
    // @keyframes rotate6 {
    //   0% {
    //     transform: rotate(0deg)
    //   }
    //   100% {
    //     transform: rotate(360deg)
    //   }
    // }
  }
</style>
